module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAD0SURBVHgBTZDBbcJAEEX/buyccnAJPqIoRN4SOEchcQVJC1QAJUAFQAXmgMXRJYzFAXFjS+CIZLHLjLFh57Aj/X3z52swLOn0uaU/dPVeUjbc0mlQUIqgtHJYe2DVw4cvU3OzcYwqhPX+28y8dwuG5+Im4kuDXAHnEFb9BK9bcftpGphjbmxWUOJeQd63g0aFORiuuKXyUefmnO0odQ4Vw1aHoH+uSOS5PLUkeriVtFQemb672QG7xezGGlgbteBHSVMWfrXCSKCU80VXFOIukMSIOmjmHfJ63J4GbzEKzpR0kBUtYuGf+2Q/Npv+4DqI0Ee7AQUtcM3aKnEDAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ExternalLink_2.png
// module id = zvl2
// module chunks = 18